var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "employment-doc-view",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "employment-doc-view__side",
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('employment-doc-side', _vm._g(_vm._b({
    model: {
      value: _vm.index,
      callback: function ($$v) {
        _vm.index = $$v;
      },
      expression: "index"
    }
  }, 'employment-doc-side', {
    pages: _vm.pages
  }, false), {
    input: _vm.scroll
  }))], 1), _c('v-col', {
    staticClass: "d-none d-lg-block",
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _c('v-col', {
    staticClass: "employment-doc-view__body",
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('employment-doc-body', _vm._g(_vm._b({
    ref: "employment-doc-body",
    model: {
      value: _vm.items,
      callback: function ($$v) {
        _vm.items = $$v;
      },
      expression: "items"
    }
  }, 'employment-doc-body', {
    pages: _vm.pages,
    index: _vm.index,
    mode: _vm.mode
  }, false), {
    input: _vm.emit,
    setIndex: _vm.setIndex
  })), _c('employment-doc-zoom', _vm._b({
    staticClass: "employment-doc-view__zoom"
  }, 'employment-doc-zoom', {
    mode: _vm.mode,
    hideZoom: _vm.hideZoom
  }, false)), _c('employment-doc-down', _vm._g(_vm._b({
    staticClass: "employment-doc-view__down"
  }, 'employment-doc-down', {
    mode: _vm.mode,
    loading: _vm.loading
  }, false), {
    down: _vm.down
  }))], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }